export default __webpack_public_path__ + "static/media/Sisters400.a9d843b9.jpg";